import { Component, OnInit, ViewChild } from '@angular/core';
import { HttpService } from '../http.service';
import { SnackbarService } from '../snackbar.service';
import { MatPaginator, PageEvent } from '@angular/material';
import { DateTime } from "luxon";

@Component({
  selector: 'app-mwg-dashboard',
  templateUrl: './mwg-dashboard.component.html',
  styleUrls: ['./mwg-dashboard.component.scss']
})
export class MwgDashboardComponent implements OnInit {
  
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  constructor(private http: HttpService, private snackbar: SnackbarService,
  ) { }
  totalMwgCount =0;
  showLoader: any;
  minDate: any;
  fromDate: any;
  toDate: any;
  mwgDatasource: any;
  mwgArray; any;
  displayedColumns = [
    'sno',
    'sin',
    'pickup',
    'shipper',
    'material',
    'vehicle',
    'doNumber',
    'loadedWeight',
    'capacity',
    'mwga',
    'status',
  ]
  totalvehicles: any;
  statuses = ['Approved', 'Pending', 'Disapproved'];
  selectedSIN: any;
  selectedVehicle: any;
  selectedDo: any;
  selectedStatus = 'Pending';
  mwgFilter: any = {
    limit: 0,
    skip: 0,
  };
  pageEvent: PageEvent;
  // pageNavigate($event: any) {
  //   throw new Error('Method not implemented.');
  // }

  ngOnInit() {
    this.getMwgDetails();
  }

  getMwgDetails(filter: any = {}) {
    filter = {
      ...(this.fromDate && { from: DateTime.fromJSDate(this.fromDate).startOf("day").toUTC() }),
      ...(this.toDate && { to: DateTime.fromJSDate(this.toDate).endOf("day").toUTC() }),
      ...(this.selectedStatus && { status: this.selectedStatus.toLocaleUpperCase() }),
      ...(this.selectedSIN && { sin: this.selectedSIN }),
      ...(this.selectedVehicle && { vehicle: this.selectedVehicle }),
      ...(this.selectedDo && { doNumber: this.selectedDo }),
    };
    filter.limit = this.paginator.pageSize || 10;
    filter.skip = this.paginator.pageIndex * (this.paginator.pageSize || filter.limit);
    this.http.get('getMwg', filter, 2).subscribe(
      (data: any) => {
        if (data.statusCode === 200) {
          this. mwgDatasource = data.data.mwg;
          this.totalMwgCount = data.data.count;
          } 
  
        },
      (err: any) => {
        this.snackbar.openSnackBar(err.error.message, '', 'err');
      }
    );
  }
  pageNavigate(event: PageEvent) {
    this.mwgFilter.limit = event.pageSize;
    this.mwgFilter.skip = event.pageIndex * event.pageSize;
    this.getMwgDetails(this.mwgFilter);
  }
  selectStatus(element) {
    this.selectedStatus = element;
    this.getMwgDetails();
  }
}
